export default class FilterTaber {
    constructor(list) {
        let self = this;

        this.props = {
            list: list
        };
        this.data = {
            items: [],
            uniqueCategories: [],
            categories: [],
        };

        $(document).off('click', '.filter-taber-handler');
        $(document).on('click', '.filter-taber-handler', function () {
            let $button = $(this);
            let $buttonList = $button.closest('.filter-taber-list');
            let category = $(this).text();
            let $body = $button.closest('.configurator-select-body');
            let $items = $body.find('.list .item');

            $buttonList.find('.filter-taber-handler').removeClass('selected');
            $button.addClass('selected');

            $items.each((index, el) => {
                let categories = $(el).attr('data-category');
                let display = 'none';

                if(categories.includes(category)) {
                    display = 'block';
                }

                $(el).css({
                    'display': display
                });
            });

            return false;
        });

        let notExistSelected = true;
        $('.filter-taber-list .item').first().children().addClass("selected").trigger("click");
        $(list).find('.item').each(function (index, el) {
            let isSelected = $(el).is('.selected');
            let categories = self.getCategories($(el));
            let existSelected = false;

            if(!isSelected) {
                $(el).css({
                    'display': 'none'
                });
            }

            categories.forEach((categorySlug) => {
                self.data.items.push({category: categorySlug, selected: isSelected});

                if(self.data.uniqueCategories.includes(categorySlug)) {
                    for(let index in self.data.categories) {
                        if(self.data.categories.hasOwnProperty(index)) {
                            if(self.data.categories[index].name === categorySlug && isSelected && notExistSelected) {
                                self.data.categories[index].selected = existSelected === false ? isSelected : false;
                                existSelected = true;
                                notExistSelected = false;
                                break;
                            }
                        }
                    }
                }else {
                    self.data.uniqueCategories.push(categorySlug);
                    self.data.categories.push({name: categorySlug, selected: existSelected === false ? isSelected : false});
                    existSelected = true;
                }
            });
        });

        if(!this.existSelected() && typeof this.data.categories[0] !== 'undefined') {
            this.data.categories[0].selected = true;
        }

        this.generateCategoryList();
        this.toggleItems();
    }

    getCategories($el) {
        let category = $el.attr('data-category');
        let categories = [];

        if(category.includes(', ')) {
            categories = category.split(', ');
        }else {
            categories.push(category);
        }

        return categories;
    }

    toggleItems() {
        $(this.props.list).find('.item').each((index, el) => {
            let list = this.data.categories;
            let $el = $(el);
            let category = $(el).attr('data-category');
            let display = 'none';

            for(let key in list) {
                if(list.hasOwnProperty(key) && list[key].selected && category.includes(list[key].name)) {
                    display = 'block';
                }
            }

            $el.css({
                'display': display
            });
        });
    }

    getPossibleCategories($list, data) {
        let categories = [];
        let $wrapper = $list.closest('.configurator-select');
        let categoriesOrder = $wrapper.attr('data-categories-order');

        if(typeof categoriesOrder === 'string' && categoriesOrder.length > 1) {
            categoriesOrder = categoriesOrder.split(',');
            categories = [];

            categoriesOrder.forEach((name) => {
                data.forEach((item) => {
                    if(name === item.name) {
                        categories.push(item);
                    }
                })
            });
        }

        return categories.length ? categories : data;
    }

    generateCategoryList() {
        if(this.data.categories.length > 1) {
            let categories = this.getPossibleCategories($(this.props.list), this.data.categories);
            let html = '<div class="filter-taber-list d-flex">';

            categories.forEach((el) => {
                html += `<div class="item"><a class="filter-taber-handler ${el.selected ? 'selected' : ''}">${el.name}</a></div>`;
            });

            html += '</div>';

            $(html).insertBefore($(this.props.list));
        }
    }

    existSelected() {
        let existSelected = false;

        this.data.categories.forEach((el) => {
            if(el.selected) {
                existSelected = true;
            }
        });

        return existSelected;
    }

}